import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const LogoInstitutionals = () => {
  return (
    <>
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-around',
          marginBottom: 45,
          height: 100,
        }}
      >
        <StaticImage
          src="../../data/images/institutionals/moncompteformation_rvb.png"
          alt="logo Mon Compte Formation"
          css={{ height: '100%', width: 250 }}
          imgStyle={{
            objectFit: 'contain',
          }}
        />
        <StaticImage
          src="../../data/images/institutionals/France-travail.png"
          alt="logo France Travail"
          css={{ height: '100%', width: 250 }}
          imgStyle={{
            objectFit: 'contain',
          }}
        />
        <StaticImage
          src="../../data/images/institutionals/region-ile-de-france-logo-vector (2).png"
          alt="logo France Travail"
          css={{ height: '100%', width: 250 }}
          imgStyle={{
            objectFit: 'contain',
          }}
        />
      </div>
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-around',
          height: 100,
        }}
      >
        <StaticImage
          src="../../data/images/institutionals/logo-transitions-pro.png"
          alt="logo France Travail"
          css={{ height: '100%', width: 250 }}
          imgStyle={{
            objectFit: 'contain',
          }}
        />
        <StaticImage
          src="../../data/images/institutionals/fifpl-organisme-financement.png"
          alt="logo France Travail"
          css={{ height: '100%', width: 250 }}
          imgStyle={{
            objectFit: 'contain',
          }}
        />
        <StaticImage
          src="../../data/images/institutionals/anfh-logo 2.png"
          alt="logo France Travail"
          css={{ height: '100%', width: 250 }}
          imgStyle={{
            objectFit: 'contain',
          }}
        />
      </div>
    </>
  );
};

export default LogoInstitutionals;
